import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Maheboob Baig — All Rights Reserved.</p>
    </footer>
  );
}
